import { type User } from '../models/User'

export const getUserName = (firstName?: string, lastName?: string) => {
  return `${firstName ? firstName : ''}${firstName && lastName ? ' ' : ''}${lastName ? lastName : ''}`
}

export const getInitials = (name?: string) => {
  try {
    if (!name) {
      return ''
    }

    const parts = name.trim().split(/\s+/)

    if (parts.length === 1) {
      return parts[0][0].toUpperCase()
    }

    return (parts[0][0] + parts[1][0]).toUpperCase()
  } catch {
    return ''
  }
}

export const getUserInitials = (user?: Pick<User, 'firstName' | 'lastName' | 'name'> | null, fallbackName?: string) => {
  return getInitials(getUserName(user?.firstName, user?.lastName) || user?.name || fallbackName)
}
